import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const initializeKingsHero = (element) => {
  return new Swiper(element, {
    modules: [Navigation],
    spaceBetween: 20,
    slidesPerView: 1,
    loop: true,
    centeredSlides: false,
  });
};

let elements = [...document.querySelectorAll('.kings-hero')];

elements.map(element => initializeKingsHero(element));